


































import { Component, Vue, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import ApplicationHeaderBar from "@/components/header/ApplicationHeaderBar.vue";
import VrSpaceContents from "@/components/vr-spaces/VrSpaceContents.vue";
import { Sweep } from "@/params/Sweep";
import { TagContentsParam } from "@/params/TagContentsParam";
import VrTagContents from "@/components/vr-tags/VrTagContents.vue";
import VrLiveStreaming from "@/components/vr-live/VrLiveStreaming.vue";

/**
 * Viewコンポーネント
 * VREEコンテンツの概要を示すためのサンプルモックアップアプリ
 */
@Component({
  components: {
    VrLiveStreaming,
    VrTagContents,
    VrSpaceContents,
    ApplicationHeaderBar
  },
  computed: mapState(['isOpenLiveStreaming', 'liveContentNo']),
  head: {
    title: {
      inner: 'Overview Sample'
    }
  }
})
export default class OverviewSample extends Vue {

  // VRスペースの参照
  public vrSpace: VrSpaceContents;
  // アプリケーションヘッダーの参照
  public headerBar: ApplicationHeaderBar;
  // 現在のカメラ位置オブジェクト（Sweep）
  private currentSweep: Sweep = null;
  // 選択タグのコンテンツ
  private selectTagContents: TagContentsParam = null;
  // ライブストリーミングコンテンツを表示するかのフラグ
  private isShownLiveStreaming: boolean = false;
  // タグコンテンツを表示するかのフラグ
  private isShownTagContents: boolean = false;

  /* Watcher */
  /**
   * ライブストリーミングコンテンツの開始を監視
   */
  @Watch('isOpenLiveStreaming')
  onChangeOpenLiveStreaming (newValue, oldValue) {
    if (newValue === oldValue) { return; }

    if (newValue) {
      // 時間差でステージコンテンツを表示する
      setTimeout(() => {
        this.isShownLiveStreaming = true;
      }, 100);
    }
  }


  /* Lifecycle Hook */
  mounted (): void {
    this.$nextTick(() => {
      this.vrSpace = <VrSpaceContents> this.$refs.vrSpace;
      this.headerBar = <ApplicationHeaderBar> this.$refs.headerBar;
    });
  }

  beforeDestroy (): void {
    console.log('View Component Destroy');
  }


  /* EventHandler */
  /**
   * Sweepの変更時
   */
  private onUpdateCurrentSweep (sweep: Sweep): void {
    this.currentSweep = sweep;
  }

  /**
   * Mattertagボタンがクリック／タップされた時
   */
  private onClickTagButton (tagContents: TagContentsParam): void {
    // 選択されたコンテンツがライブストリーミングだった場合
    if (tagContents.type === 'liveStreaming') {
      console.log('Live Streaming Tag');
      this.$store.dispatch('startLiveStreaming', { contentNo: tagContents.liveContents.contentNo });
      return;
    }

    // ライブストリーミング以外のコンテンツだった場合
    this.selectTagContents = tagContents;
    this.isShownTagContents = true;
  }

  /**
   * コンテンツを閉じた時
   */
  private onCloseTagContents (): void {
    this.isShownTagContents = false;
    this.selectTagContents = null;
  }

  /**
   * ライブストリーミングコンテンツのクローズ時
   */
  private onCloseLiveStreaming (): void {
    this.isShownLiveStreaming = false;
    // コンテンツを閉じるアニメーション動作が入るので200ミリ秒遅れて更新する
    setTimeout(() => {
      this.$store.commit('closeLiveStreaming');
    }, 200);
  }



}
